import { Container } from '@mui/material';
import React from 'react';
import { withErrorBoundary } from 'react-error-boundary';

import { ErrorBoundaryFallback } from '@components/ErrorBoundaryFallback';
import ShareCollectionButton from '@components/ShareButton/ShareCollectionButton';

import { useGetImmunizations } from '@hooks/api/immunization';

import { ShareType } from 'generated/types';

import ImmunizationList from './ImmunizationList';

const ImmunizationsMain: React.FC = () => {
  const { data, loading } = useGetImmunizations();

  return (
    <>
      <ShareCollectionButton share_type={ShareType.Immunizations} />
      <Container sx={{ maxWidth: '500px' }}>
        <ImmunizationList immunizations={data} loading={loading} />
      </Container>
    </>
  );
};

export default withErrorBoundary(ImmunizationsMain, {
  FallbackComponent: ErrorBoundaryFallback,
});
